export default "__VITE_ASSET__28cbb41a__"